import { NameAnd } from "@me8eon/record_utils";

export type BoostIndexConfig = NameAnd<BoostIndexDetails>;
export type BoostIndexDetails = {
    boost: number;
    terms: string[];
};

// Internal inverted map type: term -> index + boost
type InvertedBoostMap = Record<string, { index: string; boost: number }>;

type OneFunctionScore = { filter: { term: { _index: string } }; weight: number };
type NewFunctionScore = { _index: string, weight: number };
export type NewFunctionArr = NewFunctionScore[];

export type FunctionScoreResult = OneFunctionScore[]

/**
 * Given a config mapping index names to boost and terms,
 * returns a function that produces a function_score snippet
 * based on which terms appear in the query string.
 */
export const boostFunctionScore = (boostIndexConfig: BoostIndexConfig) => {
    // Build term -> { index, boost } map
    const inverted: InvertedBoostMap = {};
    for (const [index, details] of Object.entries(boostIndexConfig)) {
        for (const term of details.terms) {
            inverted[term.toLowerCase()] = { index, boost: details.boost };
        }
    }

    /**
     * For a given query string, returns a function_score DSL snippet
     * applying per-index weights for any matching boost terms.
     */
    return (query: string): FunctionScoreResult => {
        const terms = query
            .replace(/[^\w\s]/g, "")
            .split(/\s+/)
            .filter(Boolean)
            .map(t => t.toLowerCase());

        const functions: FunctionScoreResult = [];
        for (const term of terms) {
            const found = inverted[term];
            if (found) {
                functions.push({
                    filter: { term: { _index: found.index } },
                    weight: found.boost,
                });
            }
        }
        return functions;
    };
};
export const newBoostFunctionScore = (boostIndexConfig: BoostIndexConfig) => {
    // Build term -> { index, boost } map
    const inverted: InvertedBoostMap = {};
    for (const [index, details] of Object.entries(boostIndexConfig)) {
        for (const term of details.terms) {
            inverted[term.toLowerCase()] = { index, boost: details.boost };
        }
    }

    /**
     * For a given query string, returns a function_score DSL snippet
     * applying per-index weights for any matching boost terms.
     */
    return (query: string): NewFunctionArr => {
        const terms = query
            .replace(/[^\w\s]/g, "")
            .split(/\s+/)
            .filter(Boolean)
            .map(t => t.toLowerCase());

        const functions: NewFunctionArr = [];
        for (const term of terms) {
            const found = inverted[term];
            if (found) {
                functions.push({ _index: found.index, weight: found.boost });
            }
        }
        return functions;
    };
};
